import React, { useEffect, useMemo, useState } from 'react';

const resolveApiBase = () => {
  const apiBase = (process.env.REACT_APP_API_URL || '').replace(/\/+$/, '');
  return apiBase || '/api';
};

const PublicServices = () => {
  const [html, setHtml] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const endpoint = useMemo(() => `${resolveApiBase()}/public/services-html`, []);

  useEffect(() => {
    let mounted = true;

    const load = async () => {
      setLoading(true);
      try {
        const response = await fetch(endpoint, {
          headers: { Accept: 'application/json' },
        });
        const data = await response.json();
        if (!response.ok) {
          throw new Error(data?.message || 'Unable to load services page.');
        }
        if (!mounted) return;
        setHtml(String(data?.html || ''));
        setError('');
      } catch (requestError) {
        if (!mounted) return;
        setError(requestError.message || 'Unable to load services page.');
      } finally {
        if (mounted) setLoading(false);
      }
    };

    load();
    return () => {
      mounted = false;
    };
  }, [endpoint]);

  if (loading) {
    return <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center' }}>Loading services...</div>;
  }

  if (error) {
    return (
      <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', color: '#9f1239' }}>
        {error}
      </div>
    );
  }

  return (
    <iframe
      title="Services"
      srcDoc={html}
      style={{ width: '100%', minHeight: '100vh', border: 'none', display: 'block' }}
    />
  );
};

export default PublicServices;
